/* © CNES */
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Button } from 'primereact/button';
import { useMemo } from 'react';
import { filterSections } from '../../../assets/config/filters/Referenciel';
import './CustomAccordion.scss';
/**
 * Custom Accordion Props.
 */
export interface CustomAccordionProps {
  title: string;
  children: JSX.Element;
  closed?: boolean;
}

/**
 * Custom Accordion with content.
 * @param title Title of the Accordeon.
 * @param children Content of the accordeon.
 * @param closed is accordeon closed.
 * @returns Element.
 */
export const CustomAccordion = ({
  title,
  children,
  closed,
}: CustomAccordionProps) => {
  const customTitle = useMemo(() => {
    if (title === filterSections.dataProduct.title) {
      const splitTitle = title.split('/');
      return (
        <>
          <span>{splitTitle[0]} — </span>/
          <span className="title-product">{splitTitle[1]} — </span>
        </>
      );
    }
    return;
  }, [title]);

  return (
    <>
      {title === filterSections.mission.title && (
        <Button
          id="InfoButton"
          className="p-button-rounded p-button-text"
          aria-label="Info"
          icon="pi pi-info-circle"
          tooltip="Learn more..."
          tooltipOptions={{ position: 'top' }}
          style={{ color: '#141474' }}
          onClick={() =>
            window.open(window.__RUNTIME_CONFIG__?.COLLECTIONS_URL)
          }
        />
      )}
      <Accordion
        className="customAccordion"
        multiple
        activeIndex={closed ? [] : [0]}
      >
        <AccordionTab header={customTitle || title}>{children}</AccordionTab>
      </Accordion>
    </>
  );
};
